import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaPhoneAlt, FaDownload } from 'react-icons/fa';

import CallAPI from '../../api/CallAPI';
import ApiUiController from '../../controller/ApiUiController';
import ActionController from '../../controller/ActionController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import LeadConst from '../../util/LeadConst';
import Const from '../../util/Constants';
import DB from '../../util/LocalDB';
import FieldAudio from '../common/FieldAudio';

class InnerCallList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).call;
    this.CloudCall = reactLocalStorage.getObject(Const.CloudCalling);
    this.CloudCall = this.CloudCall && Object.keys(this.CloudCall).length > 0 ? this.CloudCall : null;
    this.state = { inApiCall: false, calls: [] };

    const user = parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id);
    this.User = Const.Opt + user + Const.Opt;

    this.isAudioCall = this.model.fields && this.model.fields.audio_link && this.model.fields.audio_link.visible;
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermInnerListRestrict);

    this.actions = DB.getActions(Const.Call);
  }

  componentDidMount() { this.loadCalls(this.props.id); }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, calls: [] });
      this.loadCalls(props.id);
    }
  }

  loadCalls = id => {
    this.setState({ ...this.state, inApiCall: true });
    CallAPI.getInnerList(this.props.type, id, this.onReceived, this.onError, this.Restrict, this.User);
  };
  onError = () => this.setState({ ...this.state, inApiCall: false });
  onReceived = res => {
    if (this.props.onCount) {
      this.props.onCount('call', res.count);
    }
    this.setState({ ...this.state, inApiCall: false, calls: res.data });
  };
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      CallAPI.delete(this.state.calls[indx].id, this.onDeleteSuccess, this.onError);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Call deleted successfully', 'success');
    this.props.reload();
  };

  showAudioLink = (call, idx) => {
    let tmpUrl = Display.FieldValue(
      call,
      "audio_link",
      this.model.fields
    );
    const cloudCall = this.CloudCall;
    if (tmpUrl && tmpUrl !== "-") {
      if (cloudCall && cloudCall.appid) {
        tmpUrl = tmpUrl.replace("${appid}", cloudCall.appid);
      }
      if (cloudCall && cloudCall.secret) {
        tmpUrl = tmpUrl.replace("${secret}", cloudCall.secret);
      }
      const url = tmpUrl;
      return (
        <td key={`td_${idx}_audio_link`}>
          <FieldAudio url={url} />
          <a href={url} target="_blank" rel="noreferrer">
            <FaDownload />
          </a>
        </td>
      );
    }
    return <td key={`td_${idx}_audio_link`}> </td>;
  }

  showList = () => this.state.calls.map((call, _i) => (
    <tr key={`call_${_i + 1}`}>
      <td>{Display.FieldValue(call, 'direction', this.model.fields)}</td>
      <td>{Util.serverStringToDisplayDateTime(call.date_time)}</td>
      <td>{Display.ModelLabelValue('user', call.responsible_person)}</td>
      <td>{Display.FieldValue(call, 'feedback', this.model.fields)}</td>
      <td>{Display.FieldValue(call, 'comment', this.model.fields)}</td>
      <td>{Display.FieldValue(call, 'complete', this.model.fields)}</td>
      <td>{Display.FieldValue(call, 'duration', this.model.fields)}</td>
      {this.isAudioCall && this.model.fields["audio_link"].field_type !== "audio" ? <td>{this.showAudioLink(call, _i)}</td> : <td>{Display.FieldValue(call, 'audio_link', this.model.fields)}</td>}
      <td>{Display.ModelLabelValue('user', call.created_by)}</td>
      <td>{Display.FieldValue(call, 'created_date', this.model.fields)}</td>
      <td>
        {ActionController.checkAction(Const.PermUpdate, this.Update, this.actions, call)
          ? <span onClick={evnt => this.props.edit(call, LeadConst.Call)} className="buttons update buttons-sm">
            <FaPencilAlt /> Edit
          </span>
          : null
        }
        {ActionController.checkAction(Const.PermDelete, this.Delete, this.actions, call)
          ? <span onClick={() => this.onDelete(_i)} className="buttons delete buttons-sm"><FaTrash /> Delete</span>
          : null
        }
        {this.props.cloud_call
          ? <span onClick={() => this.props.onCloudeCall(call, LeadConst.CloudCall)}
            className="buttons delete buttons-sm"><FaPhoneAlt />Call</span>
          : null
        }
      </td>
    </tr>
  ));

  render() {
    let uiCalls = this.showList();
    if (this.state.calls.length === 0) uiCalls = <tr><td colSpan="10">No Records Found</td></tr>;
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>Calls</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Direction</th>
                  <th>Date Time</th>
                  <th>Sales Person</th>
                  <th>Feedback</th>
                  <th>Comment</th>
                  <th>Complete</th>
                  <th>Duration</th>
                  {this.isAudioCall ? <th>Audio</th> : null}
                  <th>Created By</th>
                  <th>Created Date</th>
                  <th className="actionth">Action</th>
                </tr>
              </thead>
              <tbody>
                {uiCalls}
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default InnerCallList;